export default __webpack_public_path__ + "navigation-camera-pitch-near-maneuver-enabled-1200-58eea4a92e9102b671099e88a9c68351.png";